import { type Actions, ActionType } from './roles.actions';
import { initialState, roleAdapter, type State } from './roles.state';

export function rolesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }
        case ActionType.FETCH_ROLES: {
            return { ...state, isPending: true, error: null };
        }
        case ActionType.FETCH_ROLES_SUCCEEDED: {
            return roleAdapter.setAll(action.payload.roles, { ...state, isLoaded: true, isPending: false });
        }
        case ActionType.FETCH_ROLES_FAILED: {
            return { ...state, isPending: false, error: action.payload.error };
        }

        default:
            return state;
    }
}
